import type { Question } from '@mentimeter/legacy-series-types/question';
import type { CompatibilitySlide } from '../../compatibility-types';

export const getQuestionQuizOpenProperty = (
  target: CompatibilitySlide<'quiz-open'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  if (prop === 'question_styled') {
    return staticContents.styledTitle ?? {};
  }

  return undefined;
};
